import { render, staticRenderFns } from "./certificateFile.vue?vue&type=template&id=532c53cd&"
import script from "./certificateFile.vue?vue&type=script&lang=js&"
export * from "./certificateFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports